module.exports = __webpack_public_path__ + "static/media/20ECE20.4b63ca9f.jpg";